// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"HW6_buttonsContainer__TbS4K","editableSpanContainer":"HW6_editableSpanContainer__fmtH4"};